import { ServerError, ApolloError } from "@apollo/client";
import { errorToast } from "./DPToast";

interface DPError {
  networkError: ServerError;
}

export const handleValidationErrors = (
  err: DPError,
  prefix = ""
) => {
  if (
    err.networkError &&
    err.networkError.result?.length &&
    err.networkError.response?.status === 422
  ) {
    errorToast(prefix + err.networkError.result[0].message);
  } else {
    throw new ApolloError(err);
  }
};
